import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { GlobalConstants } from '../../common/constants/global.constant';
import { map } from 'rxjs/internal/operators/map';
import { HttpMethodsService } from '../../core/routing/services/_helpers/http-methods.service';
import { CreateProfileService } from '../../core/routing/services/profile/create-profile.service';
import { AssetLibraryConstants } from '../../core/routing/services/asset-library/constants/asset-library.constant';
import { createProfileConstants } from '../../core/routing/services/profile/constants/create-profile.constant';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { AppGlobal } from '../../core/state/app-global';
import { User } from '../../modules/account/login/_models/user.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  isFromAttractLoop = false;
  direction: string;
  operatingSystemType: string;
  uploadedImageURL: string;
  isSizeContraintsEnabled: boolean;
  userId = sessionStorage.getItem('userId');
  isPackageGenerating: any = {};
  userInfo: User;
  selectedRegionalRetailerName: string;
  LOCK_CONTENT_URL = AssetLibraryConstants.ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId;
  private layoutSub = new Subject<any>();
  private previewTypeSub = new Subject<any>();
  private pageSub = new Subject<any>();
  private pageDataTologoSub = new Subject<any>();
  private emitDataToLivePreviewSub = new Subject<any>();
  private pageDataTobannerSub = new Subject<any>();
  private metaDataInfoCheckSub = new Subject<any>();
  private emitDataToProfileSub = new Subject<any>();
  private logoContentIdSub = new Subject<string>();
  private bannerContentIdSub = new Subject<string>();
  private emitCognitoUserAttributesDataSub = new Subject<any>();
  private emitLivePreviewDataToProfileSub = new Subject<any>();
  private emitLivePreviewDataToLivePreviewSub = new Subject<any>();
  private emitLivePreviewDataToLivePreviewSubCTA = new Subject<any>();
  private tabIndexSub = new Subject<any>();
  private emitDataFactTagsSub = new Subject<string>();
  private emitRefreshProfileAttractLoopSub = new Subject<any>();
  private emitSendHeroTileStatusSub = new Subject<any>();
  private emitRefreshHeroTileDataSub = new Subject<any>();
  private passwordChangeSuccessSub = new Subject<any>();
  private setNavZIndexSub = new Subject<any>();
  private ngUnsubscribe = new Subject<boolean>();
  private chromebookTriggerSub = new Subject<any>();
  private _ProfileName = new BehaviorSubject('');
  private _RegionalUser = new BehaviorSubject('');
  private _SelectedRegionalUser = new BehaviorSubject('');
  private _SelectedRegionalRetailerID = new BehaviorSubject('');
  private _PopupStatus = new BehaviorSubject(false);
  private _RetailGifStatus = new BehaviorSubject(false);
  private _presentPageValue = new BehaviorSubject('');
  private _CustomTileEnabled = new BehaviorSubject('');
  private _SrtTileEnabled = new BehaviorSubject('');
  private _DownLoadPackageReset = new Subject();
  private _HerotileTab = new BehaviorSubject('');
  private _SwitchPopUp = new BehaviorSubject(false);
  private _SwitchToSrtTab = new BehaviorSubject(false);
  private _CreateRetailBtn = new Subject<boolean>();
  private emitNavBtnClickSub = new Subject<any>();
  private viewDevicesSub = new Subject<any>();
  emitNavBtnClickObser = this.emitNavBtnClickSub.asObservable();
  private _getSocketData = new BehaviorSubject(false);

  private profileSocketSub = new Subject<any>();
  profileSocketObser = this.profileSocketSub.asObservable();

  chromebookObser = this.chromebookTriggerSub.asObservable();
  retailPageObserver = this._CreateRetailBtn.asObservable();
  layoutObser = this.layoutSub.asObservable();
  previewTypeObser = this.previewTypeSub.asObservable();
  pageObser = this.pageSub.asObservable();
  pageDataTologoObser = this.pageDataTologoSub.asObservable();
  emitDataToLivePreviewObser = this.emitDataToLivePreviewSub.asObservable();
  pageDataTobannerObser = this.pageDataTobannerSub.asObservable();
  metaDataInfoObser = this.metaDataInfoCheckSub.asObservable();
  emitDataToProfileObser = this.emitDataToProfileSub.asObservable();
  logoContentIdObser = this.logoContentIdSub.asObservable();
  bannerContentIdObser = this.bannerContentIdSub.asObservable();
  emitDataFactTagsObser = this.emitDataFactTagsSub.asObservable();
  emitCognitoUserAttributesDataObser = this.emitCognitoUserAttributesDataSub.asObservable();
  emitLivePreviewDataToProfileObser = this.emitLivePreviewDataToProfileSub.asObservable();
  emitLivePreviewDataToLivePreviewComponentObser = this.emitLivePreviewDataToLivePreviewSub.asObservable();
  emitLivePreviewDataToLivePreviewComponentObserCTA = this.emitLivePreviewDataToLivePreviewSubCTA.asObservable();
  tabIndexObser = this.tabIndexSub.asObservable();
  emitRefreshProfileAttractLoopObser = this.emitRefreshProfileAttractLoopSub.asObservable();
  emitSendHeroTileStatusObser = this.emitSendHeroTileStatusSub.asObservable();
  emitRefreshHeroTileDataObser = this.emitRefreshHeroTileDataSub.asObservable();
  passwordChangeSuccessObser = this.passwordChangeSuccessSub.asObservable();
  setNavZIndexObser = this.setNavZIndexSub.asObservable();
  isBannerCarousel = false; // IIT2-9196
  viewDevicesObser = this.viewDevicesSub.asObservable();

  constructor(
    private httpMethod: HttpMethodsService,
    private appGlobal: AppGlobal,
    private createProfileService: CreateProfileService) { }
  // Function to emit data from layout(log-content componet) to PAGE(page component) tab
  emitLayout(selected) {
    this.layoutSub.next(selected);
  }

  emitPreviewType(type) {
    this.previewTypeSub.next(type);
  }
  
  // Function to emit data from PAGE(page componet) to live-preview component
  emitPageData(contentGrpType, pageNum, data, onlytopreview?: string, sendStoredData?) {
    this.pageSub.next(data);
    if ((contentGrpType === GlobalConstants.LOGO_CONTENT_GROUP || contentGrpType === GlobalConstants.PROMO_CONTENT_GROUP ||
      contentGrpType === GlobalConstants.PRICE_CONTENT_GROUP || contentGrpType === GlobalConstants.SEGMENTS ||
      contentGrpType === GlobalConstants.BANNER_CONTENT_GROUP || contentGrpType === GlobalConstants.PARTNER_CONTENT_GROUP || GlobalConstants.CUSTOM_TILE_GROUP) && !onlytopreview) {
      // emit logocontent/promo/pricegroup
      this.pageDataTologoSub.next({ page: contentGrpType, number: pageNum, data, sendStoredData });
    }
  }

  // Function to emit URL data from PAGE(page component) to BC component
  emitURLData(contentGrpType, data) {
    // this.pageSub.next(data);
    if (contentGrpType === GlobalConstants.BANNER_CONTENT_GROUP) {
      this.pageDataTobannerSub.next({ page: contentGrpType, data });
    }
  }

  // Fuction to emit created LogoContentId to profile for patch
  emitLogoContentId(id: string) {
    this.logoContentIdSub.next(id);
  }

  // Fuction to emit created BannerContentId to profile for patch
  emitBannerContentId(id: string) {
    this.bannerContentIdSub.next(id);
  }

  // Function to emit image data from PAGE(page component) to banner-preview component
  emitDataToLivePreview(data) {
    // this.pageSub.next(data);
    this.emitDataToLivePreviewSub.next(data);
  }

  emitMetadataCheck(isMetadataAdded, bannerFunction) {
    this.metaDataInfoCheckSub.next({ flag: isMetadataAdded, type: bannerFunction });
  }

  // to send data from profil-> logo content groups/ store logos/ promo content groups to 'create profile'
  emitDataToProfile(data: any) {
    this.emitDataToProfileSub.next(data);
  }

  emitCongitoUserAtrributes() {
    this.emitCognitoUserAttributesDataSub.next();
  }

  emitLivePreviewDataToProfile(data: any) {
    this.emitLivePreviewDataToProfileSub.next(data);
  }

  emitTabIndex(data: any) {
    this.tabIndexSub.next(data);
  }
  emitDataToFactTags(data: any) {
    this.emitDataFactTagsSub.next(data);
  }

  emitRefreshProfileAttractLoop(data: any) {
    this.emitRefreshProfileAttractLoopSub.next(data);
  }

  emitLivePreviewImageData(data: any) {
    this.emitLivePreviewDataToLivePreviewSub.next(data);
  }

  emitLivePreviewCTAData(data: any) {
    this.emitLivePreviewDataToLivePreviewSubCTA.next(data);
  }

  emitSendHeroTileStatus(data: any) {
    this.emitSendHeroTileStatusSub.next(data);
  }
  scrollToBottom(className) {
    let el = document.querySelector("." + className);
    el.scrollIntoView();
  }
  scrollTopInitial() {
    window.scroll(0, 0);
  }

  emitRefreshHeroTileData(data: any) {
    this.emitRefreshHeroTileDataSub.next(data);
  }

  changeLockContentStatus(id: string, status: string, assertConstant: string) {
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userData: User) => {
        // Make a copy of the user object
        this.userInfo = { ...userData };
      });
    this.LOCK_CONTENT_URL = AssetLibraryConstants.ASSET_LIBRARY_USERS + this.userInfo.userId
      + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userInfo.userId;
    const url = this.LOCK_CONTENT_URL + assertConstant + AssetLibraryConstants.SLASH + id + AssetLibraryConstants.ACTIVE_STATUS + status;

    return this.httpMethod.patch(url, '')
      .pipe(map((res: any) =>
        res));
  }

  emitPasswordChangeSuccess() {
    this.passwordChangeSuccessSub.next();
  }

  downloadPackage(url, filename, extention) {
    let link = document.createElement("a");
    link.setAttribute(GlobalConstants.DOWNLAOD_ATTRIBUTE_NAME,filename);
    if (extention === GlobalConstants.FILE_EXTENSION_MSI) {
      link.type = 'application/octet-stream';
    }
    link.href = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  gernerateConnectedUserPackage(packageInfo,userType) {
      let param = userType === "connected" ? packageInfo.payloadData : '';
      let URL = userType === "connected" ? createProfileConstants.CREATE_PROFILE_USER +
      sessionStorage.getItem('userId') + createProfileConstants.RETAILERS +
      packageInfo.retailerID + createProfileConstants.PACKAGE + createProfileConstants.STANDARD :
      createProfileConstants.PROFILE + createProfileConstants.PACKAGE + createProfileConstants.STANDARD + createProfileConstants.OPERATING_SYSTEM + 
      createProfileConstants.SLASH + packageInfo.payloadData.operatingsystem + createProfileConstants.SELECTED_LANGUAGE + createProfileConstants.EQUALS +
      packageInfo.payloadData.locale + createProfileConstants.SELECTED_PACKAGE + createProfileConstants.EQUALS 
      + packageInfo.payloadData.standardpack + createProfileConstants.PACKAGE_TYPE + createProfileConstants.EQUALS + packageInfo.payloadData.packagetype;
      if (packageInfo?.payloadData?.standardpack === GlobalConstants.IPOS_LITE && userType === GlobalConstants.CNCTD_LWR) {
        URL = `${URL}/${GlobalConstants.IPOS_LITE}`;
        };
      return this.httpMethod.patch(URL, param)  
      .pipe(map((res: any) =>
        res));
    }
  
  generateProductMapDetails(productMapInfo) {
    // https://www.iposcentral-dev.com/packagehandler/standardpackage/productmap/{retailer-id}
    let param = productMapInfo;
    let URL = createProfileConstants.PACKAGE_HANDLER + createProfileConstants.STANDARD_PACKAGE + createProfileConstants.PRODUCT_MAP + createProfileConstants.SLASH + productMapInfo.productMapConfiguration;
    return this.httpMethod.patch(URL, param).pipe(map((res: any) => res));
  }

  generateProductMapDetailsForProfiles(productMapInfo) {
    // https://www.iposcentral-dev.com/profile/profile/productmap/{profile-id}
    let param = productMapInfo;
    let URL = createProfileConstants.PROFILE + createProfileConstants.PROFILE + createProfileConstants.PRODUCT_MAP + createProfileConstants.SLASH + productMapInfo.productMapConfiguration;
    return this.httpMethod.patch(URL, param).pipe(map((res: any) => res));
  }

  //To get product map details
  getProductMapDetails(retailerId) {
    let URL = createProfileConstants.PACKAGE_HANDLER + createProfileConstants.STANDARD_PACKAGE + createProfileConstants.PRODUCT_MAP + createProfileConstants.SLASH + retailerId;
    return this.httpMethod.get(URL).pipe(map((res: any) => res));
  }

  //To remove existing package
  removeExistingPackage() {
    let filename = (this.isPackageGenerating.extention === createProfileConstants.DEB) ?
      createProfileConstants.IPOS_FOR_DEB : createProfileConstants.IPOS;
    let URL = createProfileConstants.PACKAGE + createProfileConstants.STANDARD + createProfileConstants.SLASH +
      this.isPackageGenerating.payloadData.packagetype + createProfileConstants.SLASH +
      this.isPackageGenerating.payloadData.locale + createProfileConstants.SLASH +
      this.isPackageGenerating.payloadData.standardpack + createProfileConstants.RETAILERS +
      this.isPackageGenerating.retailerID + createProfileConstants.SLASH + filename +
      this.isPackageGenerating.extention;
    this.isPackageGenerating.URL = URL;
    return this.httpMethod.delete(URL)
      .pipe(map((res: any) =>
        res));
  }

  //To set isPackageGenerating Value
  setisPackageGenerating(payloadObj) {
    this.isPackageGenerating = payloadObj;
  }

  //To get isPackageGenerating Value
  getisPackageGeneratingVal() {
    return this.isPackageGenerating;
  }

  getpackageStatus() {
    let filename = (this.isPackageGenerating.extention === createProfileConstants.DEB) ?
      createProfileConstants.IPOS_FOR_DEB : createProfileConstants.IPOS;
    let URL = createProfileConstants.PACKAGE + createProfileConstants.STANDARD + createProfileConstants.SLASH +
      this.isPackageGenerating.payloadData.packagetype + createProfileConstants.SLASH +
      this.isPackageGenerating.payloadData.locale + createProfileConstants.SLASH +
      this.isPackageGenerating.payloadData.standardpack + createProfileConstants.RETAILERS +
      this.isPackageGenerating.retailerID + createProfileConstants.SLASH + filename +
      this.isPackageGenerating.extention;
    this.isPackageGenerating.URL = URL;
    return this.httpMethod.head(URL)
      .pipe(map((res: any) =>
        res));
  }

  emitNavZIndex(value: boolean) {
    this.setNavZIndexSub.next({ setZIndex: value });
  }
  //To emit chrombook selection from Parent to child/ other components
  emitChromeBookSelection(value: boolean) {
    this.chromebookTriggerSub.next(value);
  }
  // To get profile name for content preview.
  public get getProfileName() {
    return this._ProfileName.asObservable();
  }
  public editProfileName(data) {
    this._ProfileName.next(data);
  }
  // To get selected and list of regionalHQ
  public get getRegionalUserDetails() {
    return this._RegionalUser.asObservable();
  }
  public displayRegionalDetails(data) {
    this._RegionalUser.next(data);
  }
  public get getSelectedRegionalUserDetails() {
    return this._SelectedRegionalUser.asObservable();
  }
  public displaySelectedRegionalDetails(data) {
    this._SelectedRegionalUser.next(data);
  }
  public get getRegionalRetailerIds() {
    return this._SelectedRegionalRetailerID.asObservable();
  }
  public displayRegionalRetailerIDs(data) {
    this._SelectedRegionalRetailerID.next(data);
  }
  public get getRetailerListPopupFlag() {
    return this._PopupStatus.asObservable();
  }
  public setRetailerListPopupFlag(data) {
    this._PopupStatus.next(data);
  }
  public get getRetailGifValue() {
    return this._RetailGifStatus.asObservable();
  }
  public setRetailGifValue(data) {
    this._RetailGifStatus.next(data);
  }
  public get getCustomTileEnabled() {
    return this._CustomTileEnabled.asObservable();
  }
  public setCustomTileEnabled(data) {
    this._CustomTileEnabled.next(data)
  }
  public get getSrtTileEnabled() {
    return this._SrtTileEnabled.asObservable();
  }
  public setSrtTileEnabled(data) {
    this._SrtTileEnabled.next(data)
  }

  public setHeroTab(data) {
    this._HerotileTab.next(data);
  }
  public setProfileWebSocketData(data) {
    this._getSocketData.next(data);
  }
  public get getProfileWebSocketData() {
    return this._getSocketData.asObservable();
  }
  public get getHerotab() {
    return this._HerotileTab.asObservable();
  }
  public setSwitchstatus(data) {
    this._SwitchPopUp.next(data);
  }

  public get getSwitchstatus() {
    return this._SwitchPopUp.asObservable();
  }
  public setToSrtTab(data) {
    this._SwitchToSrtTab.next(data);
  }
  public get getToSrtTab() {
    return this._SwitchToSrtTab.asObservable();
  }
  public setPackageStatus(data) {
    this._DownLoadPackageReset.next(data);
  }
  public get getPackageStatus() {
    return this._DownLoadPackageReset.asObservable();
  }
  //Method to Pass toggle value from Parent(HeroTile) To child(mini-live-preview)
  public passNavBtnClicks(data) {
    this.emitNavBtnClickSub.next(data);
  }
  public setCreateRetailPage(data: boolean) {
    this._CreateRetailBtn.next(data);
  }

  public get getPresentPageValue() {
    return this._presentPageValue.asObservable();
  }
  public setPresentPageValue(data) {
    this._presentPageValue.next(data);
  }

  //IIT2-5802
  fetchStandardPKGData(retailerID,userType){
    let url = AssetLibraryConstants.stdPkgURL +  AssetLibraryConstants.userType + userType;
    if(userType === "connected"){
      url += AssetLibraryConstants.retID + retailerID;
    }
    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  //To convert Numbers -> words
  convertNumberToWords(num){
    let numbersData={
      1: GlobalConstants.ONE,
      2: GlobalConstants.TWO,
      3: GlobalConstants.THREE,
      4: GlobalConstants.FOUR,
      5: GlobalConstants.FIVE,
      6: GlobalConstants.SIX,
      7: GlobalConstants.SEVEN,
      8: GlobalConstants.EIGHT,
      9: GlobalConstants.NINE,
      10: GlobalConstants.TEN
    }
    return numbersData[num];
  }
  getRetailerConfig(userId,retailerId) {
    return new Promise((resolve, reject) => {
      this.createProfileService.getUserRoleData(userId,retailerId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          const config = JSON.parse(data?.retailer?.configurations);
          resolve(config);
        })
    })
  }
  emitViewDevices(data){
    this.viewDevicesSub.next(data);
  }
  //minified version to convert number to formatted size
  formatSize(a){let b=0,c=parseInt(a,10)||0;for(;1024<=c&&++b;)c/=1024;return c.toFixed(10>c&&0<b?1:0)+" "+["bytes","KB","MB","GB","TB","PB","EB","ZB","YB"][b]}

  convertValueToText(val){
    if(val === GlobalConstants.DEVICE_TYPE_PORTABLE_VAL){
      return GlobalConstants.DEVICE_TYPE_PORTABLE_TEXT;
    }else if(val === GlobalConstants.DEVICE_ALL_INONE_DESKTOP){
      return GlobalConstants.DEVICE_ALL_INONE_DESKTOP_VAL;
    }else{
      return val;
    }
  }
  //IIT2-14840
  fetchProfileSub(){
    this.profileSocketSub.next();
  }
}
